export default __webpack_public_path__ + "static/media/u2.7cd9d86f.jfif";